/**
 * Legacy AuthenticationService entry point — kept ONLY for backwards
 * compatibility with existing imports across b2b-ui.
 *
 * The real implementation lives at:
 *   apps/b2b-frontend/app/core/auth/authentication.service.ts
 *
 * The Angular 18 service is registered in AngularJS via downgradeInjectable
 * under both 'AuthenticationService' and 'AuthService' (see
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts).
 *
 * Existing consumers continue to:
 *   - inject 'AuthenticationService' / 'AuthService' (no change needed)
 *   - import { AuthenticationService } from '@b2b/common/services/auth/authentication.service'
 *     (this file re-exports the type so the import keeps working)
 */
import angular from 'angular';

// Re-export the unified service & types so existing imports keep working.
export {
  AuthenticationService,
  type AuthenticationState,
  type AuthenticationStatus,
  type AuthenticationEvents,
} from '@ng/core/auth/authentication.service';

/**
 * Empty AngularJS module — kept so feature modules that depend on
 * 'acme.common.service.authentication' still bootstrap. The actual factory
 * is registered in ng-downgraded-components.ts.
 */
export const AuthenticationServiceModule = angular.module('acme.common.service.authentication', [
  'acme.common.service.api',
  'acme.common.service.auth',
  'acme.common.service.tenant',
]).name;
